import React from "react";
import { useLocation } from "react-router-dom";
import {
  FiPhoneCall,
  FiHeadphones,
  
} from "react-icons/fi";

const TOLL_FREE_NUMBER = "1800-12398-6666"; // Your actual number
const CALL_NUMBER = "1800123986666"; 

const TollFree = () => {
  const location = useLocation();

  // Display only on homepage
  if (location.pathname !== "/") return null;

  return (
    <a
      href={`tel:${CALL_NUMBER}`}
      aria-label={`Call Gplus customer care at ${TOLL_FREE_NUMBER}`}
      className="
        group fixed bottom-4 right-3 sm:bottom-6 sm:right-5 lg:right-7
        z-[999] isolate
        flex items-center gap-2.5 sm:gap-3
        overflow-visible rounded-full
        border border-amber-200/70
        bg-gradient-to-r from-[#800000] via-[#f31e37] to-[#800000]
        py-2 pl-2 pr-3 sm:py-2.5 sm:pl-2.5 sm:pr-4
        text-white no-underline
        
        transition-all duration-300 ease-out
        hover:-translate-y-1
        hover:border-amber-100
        
        active:scale-[0.97]
        focus-visible:outline-none
        focus-visible:ring-4 focus-visible:ring-red-300/60
      "
    >
      {/* Animated background glow */}
      <span
        aria-hidden="true"
        className="
          pointer-events-none absolute -inset-1 -z-10
          rounded-full  blur-lg
          animate-pulse
        "
      />

      {/* Premium animated phone icon */}
      <span
        className="
          relative flex h-10 w-10 sm:h-12 sm:w-12 shrink-0
          items-center justify-center rounded-full
          border border-white/70
          bg-gradient-to-br from-[#fffaf0] to-[#f4e5ca]
          text-[#b5051b]
          shadow-[inset_0_1px_3px_rgba(255,255,255,0.9),0_3px_12px_rgba(0,0,0,0.2)]
          transition-transform duration-300
          group-hover:scale-105
        "
      >
        {/* Expanding ring */}
        <span
          aria-hidden="true"
          className="
            absolute -inset-1 rounded-full
            border border-amber-100/80
            animate-ping motion-reduce:animate-none
          "
        />

        <FiPhoneCall
          aria-hidden="true"
          className="
            relative z-10 h-5 w-5 sm:h-6 sm:w-6
            origin-center
            animate-[gplus-ring_2.2s_ease-in-out_infinite]
            motion-reduce:animate-none
          "
          strokeWidth={2.5}
        />

        {/* Live pulse indicator */}
        <span
          className="
            absolute right-0 top-0 z-20
            flex h-3 w-3 items-center justify-center
            rounded-full border-2 border-[#fff5e6]
            bg-green-800
          "
        >
          <span className="h-full w-full rounded-full bg-emerald-300 animate-ping motion-reduce:animate-none" />
        </span>
      </span>

      {/* Call information */}
      <span className="flex min-w-0 flex-col items-start">
        <span
          className="
            flex items-center gap-1.5
            whitespace-nowrap
            text-[8px] sm:text-[9px]
            font-extrabold uppercase tracking-[0.12em] sm:tracking-[0.16em]
            text-[#fcd46e]
          "
        >
          <FiHeadphones className="h-3 w-3 shrink-0" />
          Customer Care
          <span className="relative ml-0.5 flex h-2 w-2 shrink-0">
            <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-80 animate-ping motion-reduce:animate-none" />
            <span className="relative h-2 w-2 rounded-full bg-emerald-300" />
          </span>
        </span>

        <span
          className="
            mt-1 whitespace-nowrap
            text-[13px] sm:text-base lg:text-[17px]
            font-black leading-tight tracking-wide
            text-white tabular-nums
          "
        >
          {TOLL_FREE_NUMBER}
        </span>

        <span
          className="
            mt-1 whitespace-nowrap
            text-[9px] sm:text-[10px]
            font-medium tracking-wide text-white
          "
        >
          Toll-Free Helpline
        </span>
      </span>

      {/* Dedicated call action */}
      {/* <span
        className="
          ml-0.5 flex shrink-0 items-center gap-1.5 sm:gap-2
          border-l border-white pl-2.5 sm:pl-3
        "
      >
        <span
          className="
            hidden sm:flex flex-col items-center
            text-[9px] font-black uppercase tracking-wider
            leading-tight text-[#ffe5a4]
          "
        >
          <span>Call</span>
          <span>Now</span>
        </span>

        <span
          className="
            flex h-7 w-7 sm:h-9 sm:w-9
            items-center justify-center rounded-full
            bg-gradient-to-br from-white to-[#f4dfbb]
            text-[#a40719]
            shadow-sm
            transition-all duration-300
            group-hover:rotate-45 group-hover:from-white
          "
        >
          <FiArrowUpRight
            aria-hidden="true"
            className="h-4 w-4 sm:h-5 sm:w-5"
            strokeWidth={2.5}
          />
        </span>
      </span> */}

      {/* Inline keyframes — no external CSS required */}
      <style>
        {`
          @keyframes gplus-ring {
            0%, 65%, 100% { transform: rotate(0deg); }
            69% { transform: rotate(-14deg); }
            73% { transform: rotate(14deg); }
            77% { transform: rotate(-10deg); }
            81% { transform: rotate(8deg); }
            85% { transform: rotate(0deg); }
          }

          @media (prefers-reduced-motion: reduce) {
            .gplus-call-widget-motion {
              animation: none !important;
            }
          }
        `}
      </style>
    </a>
  );
};

export default TollFree;